var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm-12 table-responsive" }, [
    _c("h3", [_vm._v(_vm._s(_vm.variant.name))]),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "table table-bordered",
        attrs: { id: "menu-planner-table" }
      },
      [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "menu-header" },
            [
              _c(
                "th",
                { staticStyle: { width: "150px", "min-width": "150px" } },
                [_vm._v(_vm._s(_vm.trans("menu_planner.meal")))]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { width: "150px", "min-width": "150px" } },
                [_vm._v(_vm._s(_vm.trans("badge.badge")))]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { width: "700px", "min-width": "700px" } },
                [_vm._v(_vm._s(_vm.trans("menu_planner.final_meal")))]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { width: "150px", "min-width": "150px" } },
                [_vm._v(_vm._s(_vm.trans("menu_planner.final_meal_id")))]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { width: "150px", "min-width": "150px" } },
                [_vm._v(_vm._s(_vm.trans("meal.entity.rate")))]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { width: "150px", "min-width": "150px" } },
                [_vm._v(_vm._s(_vm.trans("meal.entity.tags")))]
              ),
              _vm._v(" "),
              _vm._l(_vm.baskets, function(basket, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    staticStyle: { width: "618px", "min-width": "618px" }
                  },
                  [_vm._v("\n        " + _vm._s(basket.name) + "\n      ")]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm.baskets.length
          ? _c(
              "tbody",
              [
                _vm._l(_vm.mealTypes, function(type, typeIndex) {
                  return [
                    _c("menu-planner-edit-variant-meal", {
                      key: typeIndex,
                      attrs: {
                        "meal-type": type,
                        variant: _vm.variant,
                        "initial-baskets": _vm.baskets,
                        date: _vm.date,
                        brand: _vm.brand
                      },
                      on: { "update-baskets-details": _vm.getBasketsDetails }
                    })
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("tfoot", [
          _c(
            "tr",
            [
              _c("th", [_vm._v(_vm._s(_vm.trans("menu_planner.details")))]),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td", { staticClass: "active" }),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _vm._l(_vm.baskets, function(basket, index) {
                return _c(
                  "td",
                  {
                    key: index,
                    class: { active: index % 2 === 0, "": index % 2 !== 0 }
                  },
                  [
                    _vm.loading
                      ? _c("span", [
                          _c("span", {
                            staticClass:
                              "glyphicon glyphicon-refresh glyphicon-refresh-animate"
                          })
                        ])
                      : _vm.basketsDetails[index]
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.caloryfic"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo
                                    .caloryfic
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.after.caloryfic"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo
                                    .caloryfic * _vm.KCAL_TO_KJ_RATIO
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.after.caloryfic_kj"
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.carbohydrate_g"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo
                                    .carbohydrateG
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.dietary_fiber_g"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo
                                    .dietaryFiberG
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.fat_g"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo.fatG
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.saturated_fatty_acids_g"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo
                                    .saturatedFattyAcidsG
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.sugars_g"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo
                                    .sugarsG
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.protein_g"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].calorificInfo
                                    .proteinG
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.rate"
                                )
                              ) +
                              "0 / 0"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.caloryfic_info.before.price_info"
                                )
                              ) +
                              "\n          " +
                              _vm._s(
                                _vm.dcNumberFormat(
                                  _vm.basketsDetails[index].priceInfo
                                )
                              )
                          ),
                          _c("br")
                        ])
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60368267", { render: render, staticRenderFns: staticRenderFns })
  }
}